import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Organization} from "../organizations/types.ts";
import {Account} from "../accounts/types.ts";

export type OrganizationAccountTypeType = 'STANDALONE' | 'ROOT' | 'MANAGED'
export type OrganizationAccountStatusType = 'ACTIVE' | 'SUSPENDED'

export enum OrganizationAccountStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export type OrganizationAccountFormType = {
                                              organizationId?: string
                                              accountId?: string,
                                          } & { [key: string]: any }

export type OrganizationAccount = {
                                      id: string,
                                      organizationId: string,
                                      organization: Organization,
                                      accountId: string,
                                      account: Account,
                                      organizationAccountStatus: OrganizationAccountStatusType,
                                      createdByUsername?: string,
                                      createdBy?: { givenName: string, familyName: string },
                                      managedByUsername?: string
                                      managedBy?: { givenName: string, familyName: string },
                                      created?: string,
                                      updated?: string,
                                  } & { [key: string]: any }


export interface IOrganizationAccountTableColumn extends ITableColumn {
    render?: (item: OrganizationAccount) => ReactNode;
}


export type ListOrganizationAccounts = {
    listOrganizationAccounts: {
        items: OrganizationAccount[],
        nextToken?: string | null
    }
}

export type GetOrganizationAccount = {
    getOrganizationAccount: OrganizationAccount
}

export type CreateOrganizationAccount = {
    createOrganizationAccount: OrganizationAccount
}

export type UpdateOrganizationAccount = {
    updateOrganizationAccount: OrganizationAccount
}

export type DeactivateOrganizationAccount = {
    deactivateOrganizationAccount: OrganizationAccount
}

export type OrganizationAccountRecordFormProps = {
    record: OrganizationAccount,
    handleSubmit: (values: OrganizationAccount) => void
    handleCancel: () => void
}
